import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { CallLogServiceRB } from 'rainbow-web-sdk/services/callLog/callLog.service';

export class CallLogPlugin extends Plugin {
    public static initialize(): CallLogPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[CallLogPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[CallLogPlugin] initialized");
            window.rainbow.plugins[CallLogPlugin.name] = new CallLogPlugin();
            CallLogServiceRB.getInstance();
        }
        return window.rainbow.plugins[CallLogPlugin.name];
    }

    private constructor() {
        super();
    }
}
